import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  Typography,
  Grid,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Chip,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ListAltIcon from '@material-ui/icons/ListAlt';
import SendIcon from '@material-ui/icons/Send';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { useAuth } from '../context/AuthContext';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  title: {
    fontFamily: 'TESLA, sans-serif',
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#f47d06',
    textShadow: '2px 2px #333',
    marginBottom: theme.spacing(1),
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.75rem',
    },
  },
  subtitle: {
    fontSize: '1rem',
    color: '#666',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  gridContainer: {
    maxWidth: 600,
  },
  navCard: {
    height: '100%',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
    },
  },
  cardContent: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  icon: {
    fontSize: 48,
    marginBottom: theme.spacing(1.5),
  },
  cardTitle: {
    fontWeight: 600,
    fontSize: '1.1rem',
  },
  dashboardCard: {
    '& $icon': { color: '#1976d2' },
  },
  placeOrderCard: {
    '& $icon': { color: '#2e7d32' },
  },
  orderBookCard: {
    '& $icon': { color: '#f47d06' },
  },
  credentialsCard: {
    '& $icon': { color: '#7b1fa2' },
  },
  userMenuContainer: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  userChip: {
    backgroundColor: '#fff',
  },
}));

function Welcome() {
  const classes = useStyles();
  const history = useHistory();
  const { user, logout, isAdmin } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleUserMenuClose();
    logout();
    window.location.href = '/login';
  };

  const navItems = [
    {
      title: 'Dashboard',
      icon: DashboardIcon,
      path: '/dashboard',
      cardClass: classes.dashboardCard,
    },
    {
      title: 'Place Order',
      icon: SendIcon,
      path: '/place-order',
      cardClass: classes.placeOrderCard,
    },
    {
      title: 'Order Book',
      icon: ListAltIcon,
      path: '/orders',
      cardClass: classes.orderBookCard,
    },
    {
      title: 'Credentials',
      icon: VpnKeyIcon,
      path: '/credentials',
      cardClass: classes.credentialsCard,
    },
  ];

  return (
    <Box className={classes.root}>
      {/* User Profile Menu */}
      {user && (
        <Box className={classes.userMenuContainer}>
          <Chip
            size="small"
            label={isAdmin() ? 'Admin' : 'User'}
            color={isAdmin() ? 'secondary' : 'default'}
            className={classes.userChip}
          />
          <IconButton
            onClick={handleUserMenuOpen}
            size="small"
            style={{ backgroundColor: '#fff' }}
          >
            <AccountCircleIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleUserMenuClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            <MenuItem disabled>
              <Typography variant="body2">
                {user.name} ({user.role})
              </Typography>
            </MenuItem>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu>
        </Box>
      )}

      <Typography className={classes.title}>
        MGM Trader
      </Typography>
      <Typography className={classes.subtitle}>
        Welcome, {user?.name || 'User'}
      </Typography>

      <Container className={classes.gridContainer}>
        <Grid container spacing={2}>
          {navItems.map((item) => (
            <Grid item xs={6} key={item.title}>
              <Card className={`${classes.navCard} ${item.cardClass}`}>
                <CardActionArea
                  onClick={() => history.push(item.path)}
                  className={classes.cardContent}
                >
                  <item.icon className={classes.icon} />
                  <Typography className={classes.cardTitle}>
                    {item.title}
                  </Typography>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Welcome;
